var giphy_viewer_default = {
  "giphyWrapper": "aGM1L",
  "giphy_player": "RX7HH",
  "playIcon": "-tQM8",
  "gifRatio": "_6LcFK"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
